<!--
Author: TangChen
Date: 2018-12-26
Desc: 定投基金历史扣款详情，由index.js 配置引入
-->
<template>
    <div class="bizcomp-plan-deduction">
        <div class="plan-list-contain">
            <div class="plan-list-head">
                <div class="line-sign"></div>
                <div class="line-text">计划执行记录</div>
            </div>
            <el-table
                v-if="loaderFlag"
                :data="showData"
                style="width: 100%"
                class="tab-list-tit table-list"
            >
                <el-table-column
                    prop="transactiondate"
                    label="每期扣款日期"
                    align="center"
                    :formatter="formatterDate"
                />
                <el-table-column
                    v-if="planType == 'a'"
                    prop="fundname"
                    label="基金产品名称+代码"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.fundname + "(" + scope.row.fundcode + ")" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="confirmedamount"
                    label="每期扣款金额"
                    align="center"
                    :formatter="formatterNum"
                ></el-table-column>
                <el-table-column prop="status" label="交易状态" align="center">
                    <template slot-scope="scope">
                        <span
                            :class="
                                formatterStatus(scope.row.status) == '成功'
                                    ? 'color-e60012'
                                    : formatterStatus(scope.row.status) == '失败'
                                    ? 'color-666666'
                                    : 'color-fd6112'
                            "
                        >
                            {{ formatterStatus(scope.row.status) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="扣款方式" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ formatterPlanMode(scope.row) }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="tableData.length > conf.PAGE_SIZE" class="page-box">
                <el-pagination
                    :page-size="Number(conf.PAGE_SIZE)"
                    background
                    :current-page.sync="curPage"
                    layout="prev, pager, next"
                    :total="tableData.length"
                    v-on:current-change="dataReset"
                />
            </el-row>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";

export default {
    name: "PlanDeduction",
    mixins: [mixin],
    data() {
        return {
            tableData: [],
            conf: {}, // 初始化配置文件内容
            fund: {},
            curPage: 1,
            showData: [],
            loaderFlag: false,
            planType: "1"
        };
    },
    created() {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.planType = this.$route.query.planType;
        this.conf = this.$util.getConfig().const;
        this.getHistoryData();
    },
    methods: {
        async getHistoryData() {
            const res = await fundApi.qryAppTransService({
                planno: this.fund.planno,
                businesskind: "11"
            });
            if (res.data && res.data.data) {
                this.tableData = res.data.data;
                this.loaderFlag = true;
                this.dataReset(1);
            }
        },
        dataReset(val) {
            const _x = this.conf.PAGE_SIZE;
            if (this.tableData.length > _x) {
                this.showData = this.tableData.slice(
                    (val - 1) * _x,
                    this.tableData.length > val * _x ? val * _x : this.tableData.length
                );
            } else {
                this.showData = this.tableData;
            }
        },
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterNum(row, column, value) {
            return this.$util.fmtNum(value);
        },
        formatterStatus(value) {
            if (value == "07" || value == "02") {
                return "成功";
            } else if (value == "08" || value == "04" || value == "05" || value == "15") {
                return "失败";
            } else {
                return "处理中";
            }
        },
        formatterPlanMode(rowItem) {
            if (rowItem.paymethod == "1") {
                return this.$const.getXJBParam("sname") + "定投";
            } else {
                return rowItem.custtag == "1" ? "省钱购定投" : "银行卡定投";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-plan-deduction {
    background: #ffffff;
    .plan-list-contain {
        padding: 0 21px 20px;
        .plan-list-head {
            display: flex;
            padding: 20px 0 15px;
            height: 20px;
            line-height: 20px;
            .line-sign {
                width: 3.71px;
                height: 16px;
                margin-top: 2px;
                background: var(--color-primary);
                margin-right: 6.5px;
            }
            .line-text {
                font-size: 18px;
                color: #333333;
            }
        }
        .table-list {
            border-left: 1px solid #f1f1f1;
            border-right: 1px solid #f1f1f1;
        }
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
    .color-e60012 {
        color: var(--color-primary);
    }
    .color-666666 {
        color: #666666;
    }
    .color-fd6112 {
        color: #fd6112;
    }
}
</style>
